import React, { useEffect, useState } from "react";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";
import "react-country-state-city/dist/react-country-state-city.css";
import { State } from "country-state-city";
import './customselect.css';

const CustomSelect = () => {
  const [states, setStates] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredStates, setFilteredStates] = useState([]);
  const [popup, setPopup] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  const selectedStateFromURL = searchParams.get("state");
  const [selectedState, setSelectedState] = useState(selectedStateFromURL || "Gujarat");

  useEffect(() => {
    const { getStatesOfCountry } = require("country-state-city").State;
    const fetchedStates = getStatesOfCountry("IN");
    setStates(fetchedStates);
    setFilteredStates(fetchedStates);
  }, []);

  useEffect(() => {
    const filtered = states.filter(state =>
      state.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredStates(filtered);
  }, [searchTerm, states]);

  // Sync state from URL on mount
  useEffect(() => {
    const stateParam = searchParams.get("state");
    if (stateParam) {
      setSelectedState(stateParam);
    }
  }, [location.search]);

  const handleStateSelect = (name) => {
    setSelectedState(name);
    setPopup(false);

    // Update the URL with selected state
    searchParams.set("state", name);
    setSearchParams(searchParams);
  };

  return (
    <>
      <div className="custom-select">
        <button onClick={() => setPopup(true)} value={selectedState}>
          {selectedState}
        </button>
      </div>

      <div className={`state-popup-section ${popup ? "active" : ""}`}>
        <div className="search-popup">
          <div className="popup-head">
            <h3>Select Your State</h3>
            <span onClick={() => setPopup(false)}>
              <i className="fa-solid fa-circle-xmark"></i>
            </span>
          </div>

          <div className="search-input">
            <input
              type="text"
              placeholder="Search State"
              onChange={(e) => setSearchTerm(e.target.value)}
              value={searchTerm}
            />
            <span>
              <i className="fa-solid fa-magnifying-glass"></i>
            </span>
          </div>

          <div className="state-list">
            <ul>
              {filteredStates.length > 0 ? (
                filteredStates.map(({ name, isoCode }) => (
                  <li
                    key={isoCode}
                    value={name}
                    onClick={() => handleStateSelect(name)}
                  >
                    {name}
                  </li>
                ))
              ) : (
                <li className="no-state">No states found</li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomSelect;